"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var users;
        (function (users) {
            var edit;
            (function (edit) {
                class InitArgs {
                    constructor() {
                        this.isDisableEdit = false;
                        this.deleteDeviceMsg = appn.emptyString;
                        this.userId = 0;
                        this.canSeeCheckboxes = false;
                        this.providerType = appn.emptyString;
                        this.usersAjaxUserDeleteInformation = appn.emptyString;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    if (_initArgs.isDisableEdit) {
                        $('form#appnForm :input').not('.card-btn-expand-or-collapse').prop('disabled', true);
                        $('.addMetaItem').hide();
                        $('.removeDevice').hide();
                    }
                    addEvents();
                    if ($('.navbar-nav-right button[value*="Delete"]').length > 0)
                        addTrashMessage($('.navbar-nav-right button[value*="Delete"]'), $('#UserDetail_LoginId').val());
                }
                edit.init = init;
                function addEvents() {
                    $('.removeDevice').click(function (e) {
                        e.preventDefault();
                        const id = $(this).attr('id');
                        appn.dialog.confirm({
                            modalColor: 'modal-warning',
                            title: T('Delete Device'),
                            message: _initArgs.deleteDeviceMsg,
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    $('form#appnForm').append('<input type="hidden" value="' + id + '" name="RemovedDevice" />');
                                    $('form#appnForm').submit();
                                }
                            }
                        });
                    });
                    $('#btn-genIntegrationKey1').on('click', function (e) {
                        e.preventDefault();
                        createApiKey(1);
                    });
                    $('#btn-genIntegrationKey2').on('click', function (e) {
                        e.preventDefault();
                        createApiKey(2);
                    });
                    $(document).on('change', '.appnGlobalConfirmDelete input[id^="user_"]', function () {
                        $('#isMassDelete').val($('.appnGlobalConfirmDelete input[id^="user_"]').prop('checked'));
                    });
                }
                function createApiKey(userApiNumber) {
                    const $form = $('form#appnForm');
                    $form.append('<input type="hidden" name="RegenAPIKey' + userApiNumber + '" value="true" />');
                    $form.append('<input type="hidden" name="submitType" value="Save" />');
                    $form.submit();
                }
                function addTrashMessage(button, loginId) {
                    button.attr('data-deletedetail', appn.emptyString);
                    button.attr('data-deletemessage', appn.emptyString);
                    const loginIds = [];
                    loginIds.push(loginId);
                    appn.ajax.post({
                        url: _initArgs.usersAjaxUserDeleteInformation,
                        dataType: 'json',
                        data: { userLoginIds: loginIds, requestingProviderId: appn.requestProvider.id },
                        done: function (userDetailLists) {
                            const userDetailsList = [];
                            userDetailLists.forEach(function (userDetailList, index, original) {
                                const topUser = userDetailList.filter((o, i, a) => {
                                    return o.ProviderId === appn.requestProvider.id;
                                })[0];
                                userDetailsList.push({
                                    Id: topUser.Id,
                                    FullName: `${topUser.LastName}, ${topUser.FirstName}`,
                                    Email: topUser.Email,
                                    LoginId: topUser.LoginId,
                                    Count: userDetailList.length,
                                    FirstName: topUser.FirstName,
                                    LastName: topUser.LastName,
                                    Status: topUser.Status,
                                    HasWebAccess: topUser.HasWebAccess,
                                    Level: topUser.Level,
                                    Type: topUser.Type,
                                    ProviderId: appn.requestProvider.id
                                });
                            });
                            if (!appn.utils.hasValue(userDetailsList)) {
                                button.attr('disabled', 'disabled');
                                return;
                            }
                            button.removeAttr('disabled');
                            let msg;
                            let removeAllMessage = appn.emptyString;
                            let userStat = appn.emptyString;
                            const user = userDetailsList[0];
                            if (user.Count > 1 && _initArgs.canSeeCheckboxes) {
                                const hint = buildHint(user.Level);
                                const text = _initArgs.providerType === 'Vendor' ? T('Remove user from all associated clients') : _initArgs.providerType === 'Enterprise' ? T('Remove user from all associated environments') : appn.emptyString;
                                userStat = _initArgs.providerType === 'Vendor' ? T('(<b>{0}</b> associated clients)') : _initArgs.providerType === 'Enterprise' ? T('(<b>{0}</b> associated environments)') : appn.emptyString;
                                if (hint.hasValue() && text.hasValue())
                                    removeAllMessage = appn.elementBuilder.buildCheckboxWithHint(text, hint, undefined, `user_${user.Id}`, undefined, `user_${user.Id}`, undefined);
                            }
                            msg = `<p><b>${user.FullName}</b>${userStat.hasValue() ? ' ' + T(userStat, user.Count) : appn.emptyString}` + T(' and all their associated data will be permanently deleted.') + `</p>${removeAllMessage.hasValue() ? removeAllMessage : appn.emptyString}`;
                            const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                            const msgWarning = T('The selected item(s) will be <b>permanently deleted</b> with <b>no option</b> to recover this data.');
                            const p2 = appn.elementBuilder.createElement('p', 'mt-4', undefined, undefined, msgWarning);
                            button.attr('data-deletedetail', JSON.stringify(p.outerHTML));
                            button.attr('data-deletemessage', p2.outerHTML);
                        },
                        always: function () {
                            appn.dialog.removeContentSpinner($('#manageUsersDialog'));
                        }
                    });
                }
                function buildHint(level) {
                    const clientHint = T('This user is has {0} access and the organization is a client of a Vendor. Check the box to remove this user from all client accounts linked with this Vendor. If you continue without removing this user from all other clients, you may incur additional user license fees.', level === AccessLevel.VendorAdmin ? 'Vendor Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : appn.emptyString);
                    const enviroHint = T('This user is has {0} access and the organization is part of an Enterprise Toolkit. Check the box to remove this user from all environments. If you continue without removing this user from all other environments, you may incur additional user license fees.', level === AccessLevel.EnterpriseAdmin ? 'Enterprise Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : appn.emptyString);
                    return _initArgs.providerType === 'Vendor' ? clientHint : _initArgs.providerType === 'Enterprise' ? enviroHint : appn.emptyString;
                }
                let AccessLevel;
                (function (AccessLevel) {
                    AccessLevel[AccessLevel["ReadOnly"] = 10] = "ReadOnly";
                    AccessLevel[AccessLevel["User"] = 20] = "User";
                    AccessLevel[AccessLevel["Admin"] = 30] = "Admin";
                    AccessLevel[AccessLevel["EnterpriseAdmin"] = 40] = "EnterpriseAdmin";
                    AccessLevel[AccessLevel["VendorAdmin"] = 50] = "VendorAdmin";
                    AccessLevel[AccessLevel["SuperAdmin"] = 99] = "SuperAdmin";
                })(AccessLevel || (AccessLevel = {}));
            })(edit = users.edit || (users.edit = {}));
        })(users = views.users || (views.users = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
